import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccountManagementComponent } from './account-management/account-management.component';
import { LoginComponent } from './login/login.component';
import {AccountSettingsComponent} from './account-management/account-settings/account-settings.component';
import {ChangePlansComponent} from './account-management/change-plans/change-plans.component';
import {HibernateCancelComponent} from './account-management/hibernate-cancel/hibernate-cancel.component';
import {BillingInformationComponent} from './account-management/billing-information/billing-information.component';
import {isLoggedIn, roleGuard} from './_guards/auth-new.guard';
import {IntegrationsComponent} from './integrations/integrations.component';
import {DashboardComponent} from './dashboard/dashboard.component';

const routes: Routes = [

  { path: 'login', component: LoginComponent },
  { path: 'account-management', component: AccountManagementComponent, canActivate: [isLoggedIn] },
  { path: 'account-settings', component: AccountSettingsComponent, canActivate: [isLoggedIn, roleGuard('accountSettings')] },
  { path: 'change-plans', component: ChangePlansComponent, canActivate: [isLoggedIn, roleGuard('changePlanEdit')] },
  { path: 'hibernate-cancel', component: HibernateCancelComponent, canActivate: [isLoggedIn, roleGuard('billingEdit')] },
  { path: 'billing-info', component: BillingInformationComponent, canActivate: [isLoggedIn, roleGuard('billingEdit')] },
  { path: 'integrations', component: IntegrationsComponent, canActivate: [isLoggedIn, roleGuard('integrationsAccess')] },
  { path: 'dashboard', component: DashboardComponent, canActivate: [isLoggedIn] },
  { path: '', component: LoginComponent },
  { path: '**', component: LoginComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {

}
